import {
  QUESTION_TYPE__EMAIL,
  ANSWER_VALUE_MAX_LENGTH,
} from '../../../constants';
import Question from '../Question';
import QuestionText from './QuestionText';

export default class QuestionEmail extends QuestionText {
  constructor({ type = QUESTION_TYPE__EMAIL, ...other }) {
    super({ type, ...other });
  }
}

QuestionEmail.expectedValueType = {
  type: 'string',
  format: 'email',
  maxLength: ANSWER_VALUE_MAX_LENGTH,
};

QuestionEmail.editorSettings = {};

Question.types[QUESTION_TYPE__EMAIL] = QuestionEmail;
